export default "__VITE_ASSET__D_2y4jZ2__"